import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle, Loader2, XCircle } from "lucide-react";
import { getPaymentStatus } from "@/lib/api";
import { StatusShell } from "./StatusShell";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const s = await getPaymentStatus(sessionId);
        if (s.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(s.payment_status)) return setState("error");
      } catch (e) { /* keep polling */ }
      if (++tries < 10) timer = setTimeout(poll, 2000); else setState("error");
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  if (state === "checking") {
    return <StatusShell testid="payment-checking" icon={<Loader2 className="h-10 w-10 animate-spin text-cyan" />} title="Confirming your payment…" text="This only takes a moment." />;
  }
  if (state === "paid") {
    return <StatusShell testid="payment-success" icon={<CheckCircle className="h-10 w-10 text-cyan" />} title="Welcome to Tilla' Pro!" text="Your subscription is active. We'll email you as soon as Tilla' launches so you can start recording." />;
  }
  return <StatusShell testid="payment-error" icon={<XCircle className="h-10 w-10 text-pink" />} title="We couldn't confirm your payment" text="If you were charged, don't worry — contact us and we'll sort it out. Otherwise, feel free to try again." />;
}
